import GoogleMapReact from "google-map-react";

import publicConfig from "config/public";
import { mapStyles } from "utils/finder/mapStyleConfigs";

type MapProps = {
  location: {
    lon: number;
    lat: number;
  };
};

const Map = ({ location }: MapProps) => {
  const { lat, lon } = location;

  const center = { lat: lat, lng: lon };
  const zoom = 14;
  const options = {
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    draggable: false,
    gestureHandling: "none",
    keyboardShortcuts: false,
    scrollwheel: false,
    styles: mapStyles,
  };

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: publicConfig.googleMapsApiKey,
      }}
      center={center}
      zoom={zoom}
      options={options}
    >
      <div className="map-marker map-marker--md" />
    </GoogleMapReact>
  );
};
export default Map;
